// Dependencies: hls.js, plyr.js
// Verwendung: Füge das data-bg-hls-video Attribut zu einem Container hinzu,
// um ein Hintergrundvideo mit HLS-Unterstützung zu erstellen.
jQuery(window).on('load', function () {
    // Überprüfe, ob wir uns im Brizy Editor befinden
    if (window.location.href.indexOf('is-editor-iframe') != -1) {
        return;
    }

    $dependencyManager.addDependenciesCallback(['hls', 'plyr'], () => {
        // Find all containers with a data-bg-hls-video attribute
        jQuery('[data-bg-hls-video]').each(function () {
            const container = jQuery(this);
            const videoSrc = container.attr('data-bg-hls-video');
            if (!videoSrc) return;

            let bgContainer = container.find('.brz-bg').first();
            if (bgContainer.length === 0) {
                bgContainer = container;
            }

            const videoEl = jQuery('<video>', {
                playsinline: '',
                muted: '',
                autoplay: '',
                loop: '',
                controls: false,
               css: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    opacity: '0'
                }
            });

            const bgColor = bgContainer.find('.brz-bg-color').first();
            if (bgColor.length) {
                videoEl.insertBefore(bgColor);
            } else {
                bgContainer.append(videoEl);
            }

            // Sobald das Video spielt, animiere die Opazität zu 1 (fade in)
            videoEl.on('playing', function() {
                jQuery(this).animate({ opacity: 1 }, 1500);
            });

            // Initialisiere die Video-Wiedergabe via hls.js falls unterstützt
            if (Hls.isSupported()) {
                const hls = new Hls({ startLevel: 3,
                    maxBufferLength: 20,
                    maxMaxBufferLength: 60,
                    maxBufferSize: 60 * 1000 * 1000,
                    maxBufferHole: 0.5,
                  }); // Start Quality 3 = 720p (abhänging von den verfügbaren Qualitäten auf BunnyCDN)
                hls.loadSource(videoSrc);
                hls.attachMedia(videoEl[0]);
                hls.on(Hls.Events.MANIFEST_PARSED, function () {
                    videoEl[0].play().catch(err => console.error('Error trying to play:', err));
                });
            } else if (videoEl[0].canPlayType('application/vnd.apple.mpegurl')) {
                videoEl.attr('src', videoSrc);
                videoEl.on('loadedmetadata', function () {
                    videoEl[0].play().catch(err => console.error('Error trying to play:', err));
                });
            }

            // Initialisiere Plyr ohne Steuerungselemente
            const player = new Plyr(videoEl[0], {
                iconUrl: window.madPlyrIconUrl,
                controls: [],
                autoplay: true,
                muted: true,
                loop: { active: true },
                playsinline: true,
                settings: [],
                storage: { enabled: false }
            });

            // Setze den Plyr-Container so, dass er den gesamten Hintergrund abdeckt
            const plyrContainer = jQuery(player.elements.container);
            if (plyrContainer.length) {
                plyrContainer.css({
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover'
                });
            }
        });
    });
});